const meterManagementmRouter = {
  path: '/property',
  component: () => import('@/components/home.vue'),
  children: [
    {
      path: 'meter',
      name: 'meter',
      component: () => import('@/pages/property/energyCibsynption/meter/meter/index.vue'),
      meta: {
        keepAlive: true,
        title: '电表管理',
      },
    },
    {
      path: 'priceSetting',
      name: 'priceSetting',
      component: () => import('@/pages/property/energyCibsynption/meter/priceSetting/index.vue'),
      meta: {
        keepAlive: true,
        title: '片区电价设置',
      },
    },
    {
      path: 'priceDetail',
      name: 'priceDetail',
      component: () => import('@/pages/property/energyCibsynption/meter/priceSetting/detail.vue'),
      meta: {
        keepAlive: true,
        title: '查看电价详情',
      },
    },
    {
      path: 'priceAudit',
      name: 'priceAudit',
      component: () => import('@/pages/property/energyCibsynption/meter/priceSetting/detail.vue'),
      meta: {
        keepAlive: true,
        title: '审核片区电价',
      },
    },
    {
      path: 'meterAudit',
      name: 'meterAudit',
      component: () => import('@/pages/property/energyCibsynption/meter/meterAudit/index.vue'),
      meta: {
        keepAlive: true,
        title: '电表审核记录',
      },
    },
    {
      path: 'meterAuditDetail',
      name: 'meterAuditDetail',
      component: () => import('@/pages/property/energyCibsynption/meter/meterAudit/detail.vue'),
      meta: {
        keepAlive: true,
        title: '电表审核',
      },
    },
    {
      path: 'auditDetail',
      name: 'auditDetail',
      component: () => import('@/pages/property/energyCibsynption/meter/meterAudit/detail.vue'),
      meta: {
        keepAlive: true,
        title: '审核详情',
      },
    },
    {
      path: 'meterReading',
      name: 'meterReading',
      component: () => import('@/pages/property/energyCibsynption/meter/meterReading/index.vue'),
      meta: {
        keepAlive: true,
        title: '电表抄表管理',
      },
    },

    {
      path: 'meterReadDetail',
      name: 'meterReadDetail',
      component: () => import('@/pages/property/energyCibsynption/meter/meterReading/detail.vue'),
      meta: {
        keepAlive: true,
        title: '电表抄表详情',
      },
    },
    {
      path: 'meterReadRegister',
      name: 'meterReadRegister',
      component: () => import('@/pages/property/energyCibsynption/meter/meterReading/register.vue'),
      meta: {
        keepAlive: true,
        title: '抄表登记',
      },
    },
  ],
};
export default meterManagementmRouter;
